import React from 'react';
import { Field, useFormState } from 'react-final-form';

import { PLANNING_STAGE } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';

import OnboardStep, { OnboardStepProps } from '../../../OnboardStep';
import PhaseOfPlanning from '../../panes/PhaseOfPlanning';

import { MarriageIcon } from '../../../../SvgIconsV3/Marriage';
import { WeddingRingsIcon } from '../../../../SvgIconsV3/WeddingRings';
import { ListWeddingIcon } from '../../../../SvgIconsV3/ListWedding';
import { HomeHeartIcon } from '../../../../SvgIconsV3/HomeHeart';
import { CakeIcon } from '../../../../SvgIconsV3/Cake';
import Chip from '../../../../Chip';

import { Row } from '../../../OnboardContainer/OnboardContainer.styles';
import { ChipContentsWrapper } from './PhaseOfPlanningStep.styles';

type PhaseOfPlanningStepProps = Pick<OnboardStepProps, 'portalContent' | 'hed' | 'dek'>;

const PhaseOfPlanningStep = ({
  hed = 'Welcome! Where are you in the planning process?',
  dek = "Whether you're just starting to look around or in the final countdown, we've got you.",
  portalContent = <PhaseOfPlanning />,
}: PhaseOfPlanningStepProps): JSX.Element => {
  const { values } = useFormState();

  const planningProcessOptions = [
    {
      icon: <MarriageIcon height={24} width={24} />,
      label: 'Not yet engaged',
      value: PLANNING_STAGE.NOT_ENGAGED,
    },
    {
      icon: <WeddingRingsIcon height={24} width={24} />,
      label: 'Newly engaged and exploring',
      value: PLANNING_STAGE.NEWLY_ENGAGED,
    },
    {
      icon: <ListWeddingIcon height={24} width={24} />,
      label: `Planning mode but haven't booked a venue yet`,
      value: PLANNING_STAGE.PLANNING_NO_VENUE_BOOKED,
    },
    {
      icon: <HomeHeartIcon height={24} width={24} />,
      label: 'Planning mode and already booked a venue',
      value: PLANNING_STAGE.PLANNING_VENUE_BOOKED,
    },
    {
      icon: <CakeIcon height={24} width={24} />,
      label: 'Almost done, just the details left',
      value: PLANNING_STAGE.ALMOST_DONE,
    },
  ];

  const StageChips = planningProcessOptions.map(({ icon, label, value }) => (
    <Row format="1fr" key={value}>
      <Field name="wedding_planning_stage" parse={() => value}>
        {({ input, ...rest }) => {
          return (
            <Chip
              onClick={input.onChange}
              active={values.wedding_planning_stage === value}
              type="button"
              {...{ ...input, ...rest }}
            >
              <ChipContentsWrapper>
                {icon}
                {label}
              </ChipContentsWrapper>
            </Chip>
          );
        }}
      </Field>
    </Row>
  ));

  return (
    <OnboardStep
      hed={hed}
      dek={dek}
      showLoginCta
      disableButton={!values.wedding_planning_stage}
      nextButtonText="Next"
      portalContent={portalContent}
    >
      {StageChips}
    </OnboardStep>
  );
};

export default PhaseOfPlanningStep;
